export const getLatest = <T extends { id: number }>(array: T[]) => {
  if (!array || array.length === 0) return null
  const sorted = [...array].sort((a, b) => b.id - a.id)
  return sorted[0]
}
